module.exports = __webpack_public_path__ + "static/img/risk.a4c35fb1.jpg";